import { Environment } from 'Environment';
import { deviceSupportsResource } from '../deviceSupportsResource';

export function configureIos(env: Environment) {
	env.supportsResource = resource => deviceSupportsResource(resource, 'application/ios');
}
